import { RootStateOrAny, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import { FlowsState } from './reducer';

export const selectFlows = ({ flows }: RootStateOrAny): FlowsState => flows;

export const makeSelectFlowState = (stateId: string) =>
  createSelector(selectFlows, (flows: FlowsState) => flows[stateId]);
export const useFlowState = (stateId: string) => useSelector(makeSelectFlowState(stateId));
